import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    filterLocation: '',
    filterTags: [],
    filterDayTimes: {
        availabilityTimeSelected: [],
        isAllWeek: false,
        daysSelected: []
    },
    filterLanguages: [],
    filterTransportations: [],
    filterAssociations: []
};

const filtersSlice = createSlice({
    name: 'filters', initialState,

    reducers: {
        setFilterLocation: (state, action) => {
            state.filterLocation = action.payload;
        },

        removeLocation: state => {
            state.filterLocation = '';
        },

        setFilterTags: (state, action) => {
            state.filterTags = action.payload;
        },

        removeTag: (state, action) => {
            const tag = action.payload;
            state.filterTags = state.filterTags.filter(tagName => tagName !== tag);
        },

        setFilterDayTimes: (state, action) => {
            const { availabilityTimeSelected, isAllWeek, daysSelected } = action.payload;

            state.filterDayTimes.availabilityTimeSelected = availabilityTimeSelected;
            state.filterDayTimes.isAllWeek = isAllWeek;
            state.filterDayTimes.daysSelected = daysSelected;
        },

        removeDay: (state, action) => {
            const { day } = action.payload;
            const days = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'];
            const daysLetters = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];
            const dayLetter = daysLetters[days.indexOf(day)];
            state.filterDayTimes.daysSelected = state.filterDayTimes.daysSelected.filter(day => day !== dayLetter);
        },

        setFilterLanguages: (state, action) => {
            state.filterLanguages = action.payload;
        },

        removeLanguage: (state, action) => {
            const language = action.payload;
            state.filterLanguages = state.filterLanguages.filter(languageName => languageName !== language);
        },

        setFilterTransportations: (state, action) => {
            state.filterTransportations = action.payload;
        },

        removeTransportation: (state, action) => {
            const transportation = action.payload;
            state.filterTransportations = state.filterTransportations.filter(transportationName => transportationName !== transportation);
        },

        setFilterAssociations: (state, action) => {
            state.filterAssociations = action.payload;
        },

        removeAssociation: (state, action) => {
            const association = action.payload;
            state.filterAssociations = state.filterAssociations.filter(associationName => associationName !== association);
        },

        resetFilters: state => {
            state.filterLocation = '';
            state.filterTags = [];
            state.filterDayTimes = {
                availabilityTimeSelected: [],
                isAllWeek: false,
                daysSelected: []
            };
            state.filterLanguages = [];
            state.filterTransportations = [];
            state.filterAssociations = [];
        }
    }
});

const { setFilterTags, setFilterDayTimes, setFilterLanguages, setFilterTransportations, setFilterAssociations, removeAssociation, resetFilters, removeTag, removeDay, removeLanguage, removeTransportation, setFilterLocation, removeLocation } = filtersSlice.actions;

const filtersReducer = filtersSlice.reducer;

export { setFilterTags, setFilterDayTimes, setFilterLanguages, setFilterTransportations, setFilterAssociations, removeAssociation, resetFilters, removeTag, removeDay, removeLanguage, removeTransportation, setFilterLocation, removeLocation };
export default filtersReducer;